import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

const scrollEnquiry = () => document.querySelector("#wedding-enquiry")?.scrollIntoView({ behavior: "smooth" });

export const WeddingPackages = () => {
  const { t } = useLanguage();
  const packages = t("wpackages.items");

  return (
    <section data-testid="wedding-packages" className="tiled relative py-8 md:py-10 bg-[--bg-2]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="max-w-2xl mb-14">
          <p className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-6">{t("wpackages.eyebrow")}</p>
          <h2 className="font-display font-light tracking-tight leading-[1.05] text-3xl sm:text-4xl md:text-5xl text-[--text]">
            {t("wpackages.h2a")} <span className="italic text-[--gold]">{t("wpackages.h2b")}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <motion.div key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-50px" }} className={`rounded-2xl p-8 flex flex-col ${p.featured ? "bg-[--gold] text-[#14180E] border border-[--gold]" : "bg-[--surface] border border-white/10 text-[--text]"}`}>
              {p.featured && <span className="font-mono uppercase tracking-[0.2em] text-[10px] mb-4 opacity-80">{t("wpackages.badge")}</span>}
              <h3 className={`font-display text-2xl md:text-3xl ${p.featured ? "text-[#14180E]" : "text-[--text]"}`}>{p.name}</h3>
              <p className={`text-sm mt-2 mb-6 ${p.featured ? "text-[#14180E]/80" : "text-[--text-2]"}`}>{p.tagline}</p>
              <ul className="space-y-3 flex-1">
                {p.includes.map((inc, j) => (
                  <li key={j} className="flex items-start gap-2.5">
                    <Check size={16} className={`mt-0.5 shrink-0 ${p.featured ? "text-[#14180E]" : "text-[--gold]"}`} strokeWidth={2} />
                    <span className={`text-sm leading-snug ${p.featured ? "text-[#14180E]" : "text-[--text-2]"}`}>{inc}</span>
                  </li>
                ))}
              </ul>
              <button onClick={scrollEnquiry} data-testid={`package-btn-${i}`} className={`mt-8 inline-flex items-center justify-center px-6 py-3.5 rounded-full font-mono text-[11px] uppercase tracking-[0.16em] transition-colors duration-400 ${p.featured ? "bg-[#14180E] text-[--gold] hover:bg-[#0d1009]" : "bg-[--gold] text-[#14180E] hover:bg-[--text]"}`}>
                {t("wpage.plan")}
              </button>
            </motion.div>
          ))}
        </div>
        <p className="text-center font-mono uppercase tracking-[0.18em] text-[10px] text-[--text-2] mt-8">{t("wpackages.note")}</p>
      </div>
    </section>
  );
};
